module.exports = __webpack_public_path__ + "static/media/twitter.28ce92b9.svg";